// @ts-strict-ignore
import ReactRailsUJS from "react_ujs";

import { isModernBrowser } from "@shared/polyfill/isModernBrowser/isModernBrowser";
import {
  POLYFILL_SRCS,
  loadPolyfillSrcs,
} from "@shared/polyfill/loadPolyfillSrcs/loadPolyfillSrcs";

ReactRailsUJS.mountComponentsOriginal = ReactRailsUJS.mountComponents;
/* eslint-disable prefer-arrow-functions/prefer-arrow-functions */
ReactRailsUJS.mountComponents = function (...args) {
  const srcs = window[POLYFILL_SRCS];

  if (!isModernBrowser()) {
    loadPolyfillSrcs(srcs, () => {
      ReactRailsUJS.mountComponentsOriginal(...args);
    });
  } else {
    ReactRailsUJS.mountComponentsOriginal(...args);
  }
};

// react_ujs only detects Turbolinks, not @hotwired/turbo; when Turbo is loaded,
// swap its DOMContentLoaded listener for turbo:load so React mounts on visits.
if (typeof window !== "undefined" && "Turbo" in window) {
  ReactRailsUJS.removeEvent("DOMContentLoaded", ReactRailsUJS.handleMount);
  ReactRailsUJS.handleEvent("turbo:load", ReactRailsUJS.handleMount);
}

export default ReactRailsUJS;
